export default __webpack_public_path__ + "static/media/socNews.9b66ad20.png";